import React, { useRef, useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import i18next from '../../i18n.js';
import { Button } from 'react-bootstrap';
import { urls, customEventTypes } from '../../constants.js';
import { eventDispatcher } from '../../eventDispatcher.js';

const ListFilerControl = () => {
    const [searchStr, setSearchStr] = useState('');
    const location = useLocation();
    const searchInputRef = useRef(null);

    useEffect(() => {
        setSearchStr('');
    }, [location]);

    const getPlaceholder = () => {
        switch (location.pathname) {
            case urls.documentsPage:
                return i18next.t('list.documentsSearchPlaceholder');
            case urls.tasksPage:
                return i18next.t('list.tasksSearchPlaceholder');
            default:
                return i18next.t('list.searchPlaceholder');
        }
    }

    const onSearchChanged = () => {
        eventDispatcher.invokeEvent(customEventTypes.onSearchChanged, searchInputRef.current.value);
        setSearchStr(searchInputRef.current.value);
    }

    const onSearch = () => {
        eventDispatcher.invokeEvent(customEventTypes.onSearch, searchInputRef.current.value);
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            eventDispatcher.invokeEvent(customEventTypes.onSearch, searchInputRef.current.value);
        }
    }

    return (<div className='list-filter-control'>
        <input ref={searchInputRef} className='search-input' value={searchStr} onChange={onSearchChanged} placeholder={getPlaceholder()} onKeyDown={onKeyDown} />
        <Button className='header-btn filter' onClick={onSearch} />
    </div>);
}

export default ListFilerControl;